import { render, staticRenderFns } from "./PersonalDataModal.vue?vue&type=template&id=b10787be&scoped=true"
import script from "./PersonalDataModal.vue?vue&type=script&lang=js"
export * from "./PersonalDataModal.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataModal.vue?vue&type=style&index=0&id=b10787be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10787be",
  null
  
)

export default component.exports